import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// ✅ Import your local logo image
import logoImage from "../assets/Logo D.png";

const Navbar = () => {
  const [screen, setScreen] = useState("desktop");
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  function getScreen() {
    if (window.innerWidth >= 1024) return "desktop";
    if (window.innerWidth >= 768) return "tablet";
    return "mobile";
  }
  const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};


  
  useEffect(() => {
    setScreen(getScreen());
    const handleResize = () => setScreen(getScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Pricing", path: "/pricing" },
    { name: "Contact", path: "/contact" },
  ];

  const primary = "#1b7a9fff";
  const textDark = "#2b2b2b";

  const styles = {
    navBar: {
      position: "sticky",
      top: 0,
      zIndex: 999,
      background: "rgba(255, 255, 255, 0.85)",
      backdropFilter: "blur(10px)",
      borderBottom: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 4px 18px rgba(0,0,0,0.05)",
      padding: screen === "desktop" ? "18px 40px" : "14px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    logoSection: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },

    logo: {
      width: "60px",
      height: "60px",
      objectFit: "contain",
      filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))",
    },

    navLinks: {
      display: screen === "mobile" ? "none" : "flex",
      gap: screen === "desktop" ? "40px" : "25px",
      listStyle: "none",
      margin: 0,
      padding: 0,
      fontSize: "16px",
      fontWeight: 500,
    },

    link: (isActive) => ({
      textDecoration: "none",
      color: isActive ? primary : textDark,
      paddingBottom: "6px",
      position: "relative",
      fontWeight: isActive ? 700 : 500,
      transition: "0.3s",
      ...(isActive && {
        borderBottom: `3px solid ${primary}`,
      }),
    }),

    rightSection: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },

    phone: {
      display: screen === "mobile" ? "none" : "flex",
      alignItems: "center",
      gap: "6px",
      color: primary,
      fontWeight: 600,
      fontSize: screen === "desktop" ? "17px" : "14px",
    },

    btn: {
      background: primary,
      color: "#fff",
      padding: screen === "desktop" ? "0 24px" : "0 18px",
      height: screen === "desktop" ? "46px" : "40px",
      borderRadius: "8px",
      border: "none",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: "0 4px 12px rgba(111,140,255,0.35)",
      transition: "0.3s",
    },

    hamburger: {
      display: screen === "mobile" ? "flex" : "none",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "26px",
      height: "20px",
      cursor: "pointer",
    },

    bar: {
      height: "3px",
      width: "100%",
      backgroundColor: textDark,
      borderRadius: "4px",
    },

    mobileMenuOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: menuOpen ? "100%" : "0",
      height: "100vh",
      background: "rgba(0,0,0,0.45)",
      backdropFilter: "blur(4px)",
      transition: "0.3s ease",
      overflow: "hidden",
      zIndex: 9999,
    },

    mobileMenu: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "270px",
      height: "100%",
      background: "#fff",
      padding: "60px 25px",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
      boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
      transform: menuOpen ? "translateX(0)" : "translateX(270px)",
      transition: "transform 0.35s ease",
      zIndex: 10000,
    },

    mobileLink: {
      textDecoration: "none",
      color: textDark,
      fontSize: "18px",
      fontWeight: 500,
    },
  };

  return (
    <>
      <div style={styles.navBar}>
        {/* Logo Section */}
        <div style={styles.logoSection}>
          <img
            src={logoImage} // ✅ using local logo
            style={styles.logo}
            alt="Laundry Logo"
          />
          <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
            <span style={{ color: primary, fontWeight: 700, fontSize: "20px" }}>
              Rapid Wash
            </span>
            <span style={{ color: "#555", fontWeight: 500, fontSize: "12px" }}>
              Laundry & Dry Cleaning Services
            </span>
          </div>
        </div>

        {/* Desktop Nav */}
        <ul style={styles.navLinks}>
          {menuItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              (item.path !== "/" && location.pathname.startsWith(item.path));

            return (
              <li key={item.name}>
                <Link
  to={item.path}
  style={styles.link(isActive)}
  onClick={scrollToTop}
>
  {item.name}
</Link>

              </li>
            );
          })}
        </ul>

        {/* Right Section */}
        <div style={styles.rightSection}>
          <div style={styles.phone}>
            <span style={{ fontSize: 20 }}>📞</span> (+91) 93151 25347
          </div>

          <button style={styles.btn}>Make an Appointment</button>

          {/* Mobile Hamburger */}
          <div style={styles.hamburger} onClick={() => setMenuOpen(true)}>
            <div style={styles.bar}></div>
            <div style={styles.bar}></div>
            <div style={styles.bar}></div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div style={styles.mobileMenuOverlay} onClick={() => setMenuOpen(false)}>
        <div
          style={styles.mobileMenu}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              fontSize: 22,
              cursor: "pointer",
            }}
            onClick={() => setMenuOpen(false)}
          >
            ❌
          </div>

          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              style={styles.mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;
